// AdminLogin.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // ✅ use AuthContext
import "./AdminLogin.css"; // make sure this file exists

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [college, setCollege] = useState("");
  const navigate = useNavigate();

  const { loginAdmin } = useAuth(); // ✅ get loginAdmin from context

  const handleLogin = () => {
    let admins = JSON.parse(localStorage.getItem("admins")) || [];

    let found = admins.find(
      (a) =>
        a.email === email && a.password === password && a.college === college
    );

    if (found) {
      loginAdmin(found); // ✅ save into AuthContext + localStorage
      alert("✅ Login successful!");
      navigate("/admin-dashboard");
    } else {
      alert("❌ Invalid credentials!");
    }
  };

  return (
    <div className="admin-login-page">
      <h2>👨‍💼 Admin Login</h2>
      <input
        type="email"
        placeholder="Enter Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        type="password"
        placeholder="Enter Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <input
        type="text"
        placeholder="Enter College Name"
        value={college}
        onChange={(e) => setCollege(e.target.value)}
      />
      <button onClick={handleLogin}>Login</button>
    </div>
  );
}

export default AdminLogin;
